import { TableCell } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MyCheckBox from '../form/MyCheckBox'
import { setValueForm } from '../../../helpers/form/FormHelper'

const MyTableCheckBoxAll = ({ items, checked, setChecked, isReturnValues = false }) => {

    const [checkedItem, setCheckedItem] = useState(false)

    // console.log('checked', checked)
    // console.log('checkedItem', checkedItem)

    useEffect(() => {
        clearCheck()
    }, [checked])

    useEffect(() => {
        changeCheckedList()
    }, [checkedItem])
    
    const clearCheck = () => { // Знімаємо флажок якщо всі елементи не обрані
        if (checkedItem) {
            if (!checked || Object.keys(checked).length === 0) {
                setCheckedItem(false)
            }
        }
    }

    const changeCheckedList = () => {
        // Тут можливо треба буде переробити, якщо при створенні компоненту вже будуть якість обрані елементи таблиці
        if (checkedItem) { // Тут треба зробити всі елементи активними
            if (items && items.length > 0) {
                let checkedTemp = {}
                for (const item of items) {
                    if (item.id) {
                        checkedTemp[item.id] = true
                    }
                }
                setChecked(checkedTemp)
            } else {
                setChecked({})
            }
        } else { // Інакше всі елементи вимкнути
            setChecked({})
        }
    }

  return (
    <TableCell align='center' className='myTable__checkbox'>
        <MyCheckBox
            // value={false}
            value={checkedItem}
            // setValue={e => setValueForm(setChecked, id, e)}
            setValue={e => {
                setCheckedItem(e)
                // changeCheckedList(e)
                // if (isReturnValues) {
                //     setChecked({
                //         name: id, 
                //         value: e
                //     })
                // } else {
                //     setValueForm(setChecked, id, e)
                // }
            }}
            // label
        />
    </TableCell>
  )
}

export default MyTableCheckBoxAll